
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Người Cư Trú </h4>
      </div>
      <div class="modal-body">
        <!-- full_name -->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.full_name`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.full_name')" v-model="relative.full_name" id="full_name" @input="validateFieldIsEmpty('full_name')">
              <span v-if="(relative.full_name == '' || relative.full_name == null) && full_nameValidate == true" class="help is-danger">
                <font color="red">{{$t('customer.relatives.full_nameValidate')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.relationship`)}}</label>
              <select v-model="relative.relationship" class="form-control">
                <option
                  v-for="code in relative_codes"
                  v-bind:value="code.value"
                  :key="code.value"
                  >{{ $t(code.text) }}</option
                >
              </select>
              <!-- <b-form-select
                :options="relative_codes"
                v-model="relative.relationship"
                class="form-control"
              /> -->
              <span v-if="(relative.relationship == ''|| relative.relationship == null) && relative_codesValidate==true"  class="help is-danger">
                <font color="red">{{$t('customer.relatives.relationshipValidate')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.yob`)}}</label>
              <input type="number" class="form-control" :placeholder="$t('customer.relatives.yob')" v-model="relative.yob">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.gender`)}}</label>
              <select v-model="relative.gender" class="form-control">
                <option
                    v-for="gender in gender_list"
                    v-bind:value="gender.id"
                    :key="gender.id"
                >{{ $t(gender.text) }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.nationality`)}}</label>
              <b-form-select
                :options="country_list"
                v-model="relative.nationality"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.phone_number`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.phone_number')" v-model="relative.phone_number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.identification_number`)}}</label>
              <input type="number" class="form-control" :placeholder="$t('customer.relatives.identification_number')" v-model="relative.identification_number">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.passport`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.passport')" v-model="relative.passport">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{$t(`customer.relatives.notes`)}}</label>
              <textarea type="text" class="form-control" :placeholder="$t('customer.relatives.notes')" v-model="relative.notes">
              </textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
        
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex"
import constantsData from '@/lib/constantsData'
// import utils from '@/lib/utils'

export default {
  name: "RelativesInputView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      relative_codes: constantsData.relationshipOptions,
      gender_list: constantsData.genderTypes,
      country_list: [],
      relative: {
        full_name: null,
        relationship: null,
        yob: null,
        gender: 1,
        nationality: 287,
        phone_number: null,
        notes: null,
        identification_number: null,
        passport: null,
        resident_contract: null,
        resident_type: 1,
      },
      field_required:{
        'full_name':'',
        'relationship':''
      },
      full_nameValidate:false,
      relative_codesValidate:false,
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_RELATIVE_DETAIL({id:this.id}).then(
          function(res) {
            let relative_data = res
            this.relative.full_name = relative_data.full_name
            this.relative.relationship = relative_data.relationship
            this.relative.yob = relative_data.yob
            this.relative.gender = relative_data.gender
            this.relative.gender = relative_data.gender
            this.relative.nationality = relative_data.nationality
            this.relative.phone_number = relative_data.phone_number
            this.relative.identification_number = relative_data.identification_number
            this.relative.passport = relative_data.passport
            this.relative.resident_contract = relative_data.resident_contract,
            this.relative.resident_type = relative_data.resident_type
            this.relative.notes = relative_data.notes
          }.bind(this)
        )
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    ...mapActions([
      "GET_COUNTRY_LIST",
      "GET_RELATIVE_DETAIL"
    ]),
    reset: function() {
      this.relative.full_name = null
      this.relative.relationship = null
      this.relative.yob = null
      this.relative.gender = 1
      this.relative.nationality = 287
      this.relative.phone_number = null
      this.relative.identification_number = null
      this.relative.passport = null
      this.relative.notes = null
      this.relative.resident_contract = null,
      this.relative.resident_type = 1
    },
    onAdd: function() {
      if(this.relative.full_name === null || this.relative.full_name === ""){
        this.full_nameValidate=true
      }
      else if(this.relative.relationship === null || this.relative.relationship === ''){
        this.relative_codesValidate=true
      }
      else
      {
        const saveRelative = {
        full_name: this.relative.full_name,
        relationship: this.relative.relationship,
        yob: this.relative.yob,
        gender: this.relative.gender,
        nationality: this.relative.nationality,
        phone_number: this.relative.phone_number,
        identification_number: this.relative.identification_number,
        passport: this.relative.passport,
        resident_contract: this.relative.resident_contract,
        resident_type: this.relative.resident_type,
        notes: this.relative.notes
      }
      this.$emit("relative-add", saveRelative)
      }
    },
    onSave: function() {
      if(this.relative.full_name === null || this.relative.full_name === ""){
        this.full_nameValidate=true
      }
      else if(this.relative.relationship === null || this.relative.relationship === ''){
        this.relative_codesValidate=true
      }
      else
      {
        const id = this.id
        const saveRelative = {
          full_name: this.relative.full_name,
          relationship: this.relative.relationship,
          yob: this.relative.yob,
          gender: this.relative.gender,
          nationality: this.relative.nationality,
          phone_number: this.relative.phone_number,
          identification_number: this.relative.identification_number,
          passport: this.relative.passport,
          resident_contract: this.relative.resident_contract,
          resident_type: this.relative.resident_type,
          notes: this.relative.notes
        }
        this.$emit("relative-save", id, saveRelative)
        }
    },
    validateFieldIsEmpty: function(field, objectName = 'this.relative.',  objectNameRequire = 'this.field_required.' ) {

            // use for get value : this.userdata.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            }

            return result;
    },
  },
  mounted() {
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = []
        let data = res.data
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          }
          countries.push(country)
        })
        this.country_list = countries
      }.bind(this)
    )
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Customer/RelativesInputView.vue